import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuiz = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.5 12C3.5 5 5.50092 3 12.5005 3C19.5 3 21.5 5 21.5 12C21.5 19 19.4231 21 12.5005 21C5.57784 21 3.5 19 3.5 12Z",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 16H11.5",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 8H13.5",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 12H16.5",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgQuiz);
export { ForwardRef as ReactComponent };
